export enum SUBMIT_BUTTON_MODE {
  NONE = 'NONE',
  ERROR = 'ERROR',
  SUBMITTING = 'SUBMITTING',
  SUCCESS = 'SUCCESS',
}
